import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { 
  FileCheck, CheckSquare, Send, Package, 
  GitBranch, ArrowRight 
} from 'lucide-react';

const Tools = () => {
  const navigate = useNavigate();

  const tools = [
    {
      id: 'qc-sheets',
      name: 'QC Sheets',
      description: 'Quality control inspection sheets and documentation',
      icon: FileCheck,
      path: '/tools/qc-sheets',
      color: 'bg-green-500',
      stats: 'Track quality inspections'
    },
    {
      id: 'checklists',
      name: 'Checklists',
      description: 'Project task lists and completion tracking',
      icon: CheckSquare,
      path: '/tools/checklists',
      color: 'bg-blue-500',
      stats: 'Manage task lists'
    },
    {
      id: 'rfq',
      name: 'RFQ Manager',
      description: 'Request for Quote management and tracking',
      icon: Send,
      path: '/tools/rfq',
      color: 'bg-purple-500',
      stats: 'Send and track RFQs'
    },
    {
      id: 'inventory',
      name: 'Inventory',
      description: 'Material and equipment inventory management',
      icon: Package,
      path: '/tools/inventory',
      color: 'bg-orange-500',
      stats: 'Track stock levels'
    },
    {
      id: 'decision-tree',
      name: 'Decision Tree',
      description: 'Project decision tracking and scope change management',
      icon: GitBranch,
      path: '/tools/decision-tree',
      color: 'bg-indigo-500',
      stats: 'Document decisions'
    }
  ];

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-4xl font-black tracking-tight uppercase mb-2">Tools</h1>
        <p className="text-muted-foreground">Project management utilities and trackers</p>
      </div>

      {/* Tools Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tools.map((tool) => {
          const Icon = tool.icon;
          return (
            <Card 
              key={tool.id} 
              className="border-border hover:border-primary transition-all cursor-pointer group"
              onClick={() => navigate(tool.path)}
            >
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className={`p-3 rounded-lg ${tool.color} bg-opacity-10`}>
                    <Icon size={32} className={`${tool.color.replace('bg-', 'text-')}`} />
                  </div>
                  <ArrowRight 
                    size={20} 
                    className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" 
                  />
                </div>
                <CardTitle className="mt-4">{tool.name}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground mb-3">
                  {tool.description}
                </p>
                <p className="text-xs font-mono uppercase text-primary">
                  {tool.stats}
                </p>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Quick Stats */}
      <Card>
        <CardHeader>
          <CardTitle>Tool Usage</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            {tools.map((tool) => (
              <div key={tool.id} className="text-center p-4 border border-border rounded-lg">
                <p className="text-2xl font-bold">-</p>
                <p className="text-xs text-muted-foreground mt-1">{tool.name}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Tools;
